import { render, staticRenderFns } from "./ListLayoutItem.vue?vue&type=template&id=520235d6&scoped=true&"
import script from "./ListLayoutItem.vue?vue&type=script&lang=js&"
export * from "./ListLayoutItem.vue?vue&type=script&lang=js&"
import style0 from "./ListLayoutItem.vue?vue&type=style&index=0&id=520235d6&lang=scss&scoped=true&"
import style1 from "./ListLayoutItem.vue?vue&type=style&index=1&id=520235d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520235d6",
  null
  
)

export default component.exports